import i18n from "intl/i18n"

import { Guid } from "@/types"
import { formatNumber } from "utils/utils"
import Unit from "./Unit"

export interface IGetShippingOrderTransportBaseDto {
    id: Guid
    description?: string | null
    carrier?: string | null
    measurementSystemId: Guid
    dimension1?: number | null
    dimension2?: number | null
    dimension3?: number | null
    payload?: number | null
}

export interface IInitShippingOrderTransportBase {
    dto: IGetShippingOrderTransportBaseDto
    sequence: number
    sizeUnits?: Unit[]
}

export default class ShippingOrderTransportBase {
    id: Guid
    description?: string
    carrier: string
    sizeUnit?: Unit
    dimension1?: number
    dimension2?: number
    dimension3?: number
    payload?: number
    sequence: number

    constructor({
        dto,
        sequence,
        sizeUnits,
    }: IInitShippingOrderTransportBase) {
        this.id = dto.id
        this.description = dto.description || undefined
        this.carrier = dto.carrier || ""
        this.sizeUnit = sizeUnits?.find(u => u.id === dto.measurementSystemId)
        this.dimension1 = typeof dto.dimension1 === "number" ? dto.dimension1 : undefined
        this.dimension2 = typeof dto.dimension2 === "number" ? dto.dimension2 : undefined
        this.dimension3 = typeof dto.dimension3 === "number" ? dto.dimension3 : undefined
        this.payload = typeof dto.payload === "number" ? dto.payload : undefined
        this.sequence = sequence
    }

    printPayload() {
        if (typeof this.payload !== "number") return ""
        return `${formatNumber(this.payload)} ${i18n.t("common.kg")}`
    }

    printDimensions() {
        if (typeof this.dimension1 === "number"
            || typeof this.dimension2 === "number"
            || typeof this.dimension3 === "number") {
            const dimensions: string[] = [this.dimension1, this.dimension2, this.dimension3]
                .filter(d => typeof d === "number")
                .map(d => `${formatNumber(d!)} ${this.sizeUnit?.unit || ""}`)
            return dimensions.join(" × ")
        }

        return ""
    }
}
